module.exports = __webpack_public_path__ + "static/media/bubbles-kid.45d348e9.jpg";